import { useEffect, useState } from 'react';
import MapaLeaflet from './MapaLeaflet';
import MapaGoogle from './MapaGoogle';
import { obterConfig } from '../../lib/configSistema';

// Escolhe o mapa pela configuração do sistema (Configurações › Mapa, só superadmin altera):
// "openstreetmap" (padrão, sem chave) ou "google" (precisa da chave). Se o Google falhar (chave recusada,
// sem rede), cai sozinho no OpenStreetMap — o cadastro nunca fica sem mapa.
export default function MapaImovel(props) {
  const [config, setConfig] = useState(null);
  const [googleFalhou, setGoogleFalhou] = useState(false);

  useEffect(() => {
    let vivo = true;
    obterConfig().then((c) => vivo && setConfig(c.mapa));
    return () => { vivo = false; };
  }, []);

  if (!config) return <div style={{ height: 320 }} className="border rounded bg-light" />;
  if (config.tipo === 'google' && config.google_key && !googleFalhou) {
    return <MapaGoogle {...props} chave={config.google_key} aoFalhar={() => setGoogleFalhou(true)} />;
  }
  return <MapaLeaflet {...props} />;
}
